/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Navbar megamenu - Hover trigger mode for parent menu items
document.querySelectorAll("#navbar-desktop.menu-desktop-hover .nav-item.dropdown").forEach((dropdown) => {
  const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(dropdown.querySelector(".nav-link"));

  dropdown.addEventListener("mouseover", () => {
    document.querySelectorAll("#navbar-desktop.menu-desktop-hover .dropdown-menu").forEach((menu) => {
      if (menu.previousElementSibling.dataset.index !== dropdown.querySelector(".nav-link").dataset.index) {
        menu.classList.remove("show");
      }
    });
    bsDropdown.show();
  });

  dropdown.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!dropdown.matches(":hover")) {
        bsDropdown.hide();
      }
    }, 200);
  });
});

// Quantity steppers (plus/minus)
window.onClickQtyPlusMinus = (btn) => {
  const input = btn.closest(".quantity-wrapper")?.querySelector("input");
  if (!input) {
    console.log("No input field found.");
    return;
  }

  const inputValue = Number(input.value);
  console.log("Current input value:", inputValue);

  if (btn.dataset.mode === "plus") {
    input.value = inputValue + 1;
  } else {
    if (inputValue > Number(input.dataset.minQty)) {
      input.value = inputValue - 1;
    }
  }

  const event = new Event("change");
  input.dispatchEvent(event);

  // Check if the quantity button is inside .product-content
  if (btn.closest(".product-content")) {
    // updates displayed prices based on quantity
    updatePricesForQuantity(Number(input.value));
  }
};

/**  Update Price
 *   - Use `data-qty-update-hide-trailing-zeros` on an element to enable this feature.
 *   - Example:
 *   <span data-qty-update-current-price data-qty-update-hide-trailing-zeros>
 *     $5
 *   </span>
 */
// Update all quantity-dependent prices
const updatePricesForQuantity = (quantity) => {
  document
    .querySelectorAll("#product-template .rebrand-product-card__pricing, .cyg-price-container")
    .forEach((container) => {
      const currentPriceEl = container.querySelector("[data-qty-update-current-price]");
      const comparePriceEl = container.querySelector("[data-qty-update-compare-price]");

      if (!currentPriceEl) return; // No price element, skip

      // Check if the element should hide trailing zeros
      const hideTrailingZeros = currentPriceEl.hasAttribute("data-qty-update-hide-trailing-zeros");

      // Store base price if not already stored
      if (!currentPriceEl.dataset.basePrice) {
        currentPriceEl.dataset.basePrice = parseFloat(currentPriceEl.textContent.replace(/[^0-9.]/g, "")) || 0;
      }
      const baseCurrentPrice = parseFloat(currentPriceEl.dataset.basePrice) || 0;

      // **Pass `currentPriceEl` into formatPrice()**
      currentPriceEl.textContent = formatPriceGeneral(baseCurrentPrice * quantity, hideTrailingZeros, currentPriceEl);

      if (comparePriceEl) {
        if (!comparePriceEl.dataset.basePrice) {
          comparePriceEl.dataset.basePrice = parseFloat(comparePriceEl.textContent.replace(/[^0-9.]/g, "")) || 0;
        }
        const baseComparePrice = parseFloat(comparePriceEl.dataset.basePrice) || 0;

        // **Pass `comparePriceEl` into formatPrice()**
        comparePriceEl.textContent = formatPriceGeneral(baseComparePrice * quantity, hideTrailingZeros, comparePriceEl);
      }
    });
};

const formatPriceGeneral = (price, hideTrailingZeros, element = null) => {
  let formatted;
  if (element && element.hasAttribute("data-no-format")) {
    formatted = price.toFixed(2);
  } else {
    formatted = price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
    if (hideTrailingZeros) {
      formatted = formatted.replace(/\.?0+$/, "");
    }
  }
  return `$${formatted}`;
};

// Share links using WebShare API
window.onLinkShare = (btn, e) => {
  if (navigator.share) {
    navigator.share({
      title: btn.dataset.shareTitle,
      url: window.location.href,
    });
  } else {
    const popover = bootstrap.Popover.getOrCreateInstance(btn, {
      content: `
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" value="${window.location.href}">
                    <button id="btn-share-copy" class="btn btn-outline-primary" type="button">${btn.dataset.textCopy}</button>
                </div>
            `,
      html: true,
      sanitize: false,
      placement: "top",
    });

    popover.show();

    document.querySelector("#btn-share-copy")?.addEventListener("click", (e) => {
      navigator.clipboard.writeText(window.location.href);
      e.target.textContent = btn.dataset.textCopied;
    });

    setTimeout(() => {
      popover.hide();
      btn.blur();
    }, 4000);
  }
};

// Search page - set selected value for the types select field
const initSearchPageSetSelected = () => {
  const select = document.querySelector("#search-header .form-select");

  if (!select) return;

  const params = new URLSearchParams(location.search);
  const type = params.get("type");

  if (!type) return;

  select.value = type;
};
initSearchPageSetSelected();

// Countdown timers
const initCountdownTimers = () => {
  document.querySelectorAll(".countdown-timer").forEach((elem) => {
    if (elem.classList.contains("init")) return;

    elem.classList.add("init");

    let end = Number(elem.dataset.time) * 1000;

    if (window.location.href.includes("ecomify")) {
      end = Date.now() + 1.08e7;
    }

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;

    const x = setInterval(() => {
      const now = new Date().getTime();
      const difference = end - now;

      if (difference < 0) {
        clearInterval(x);
        elem.remove();
        return;
      }

      elem.removeAttribute("tw:hidden");

      const h = Math.floor(difference / hours);
      const m = Math.floor((difference % hours) / minutes);
      const s = Math.floor((difference % minutes) / seconds);

      if (elem.querySelector("[data-hours")) {
        elem.querySelector("[data-hours").innerText = `${h}${elem.dataset.textH}`;
        elem.querySelector("[data-hours").setAttribute("aria-label", `${h} ${elem.dataset.textHours}`);
      }
      if (elem.querySelector("[data-minutes")) {
        elem.querySelector("[data-minutes").innerText = `${m}${elem.dataset.textM}`;
        elem.querySelector("[data-minutes").setAttribute("aria-label", `${m} ${elem.dataset.textMinutes}`);
      }
      if (elem.querySelector("[data-seconds")) {
        elem.querySelector("[data-seconds").innerText = `${s}${elem.dataset.textS}`;
        elem.querySelector("[data-seconds").setAttribute("aria-label", `${s} ${elem.dataset.textSeconds}`);
      }

      if (h === 0) {
        elem.querySelector("[data-hours").setAttribute("hidden", "hidden");
      }
    }, seconds);
  });
};
initCountdownTimers();

document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector(".countdown-timer")) {
    initCountdownTimers();
  }
});

/*
    Animations on scroll
    fixes when the option is disabled
*/
const fixAnimationsOnScroll = () => {
  const isSettingEnabled = document.querySelector(".animations-on-scroll");

  if (!isSettingEnabled) {
    document.querySelectorAll(".animate__animated.opacity-0").forEach((elem) => {
      elem.classList.remove("animate__animated", "opacity-0");
    });
    document.querySelectorAll(".dropdown-megamenu .animate__animated").forEach((elem) => {
      elem.classList.remove("animate__animated");
    });
  }
};
fixAnimationsOnScroll();

// Shopify Official Reviews app
// https://apps.shopify.com/product-reviews
const initSprBadges = () => {
  window.SPR?.initDomEls();
  window.SPR?.loadBadges();
};
window.addEventListener("updated.ecomify.cart", initSprBadges);
window.addEventListener("updated.ecomify.collection", initSprBadges);

if (document.querySelector("#shopify-product-reviews")) {
  setInterval(() => {
    document.querySelector(".spr-summary-actions-newreview").classList.add("btn", "btn-secondary");

    document.querySelectorAll("input.spr-form-input").forEach((input) => {
      input.classList.add("form-control");
    });

    document.querySelectorAll("textarea.spr-form-input").forEach((textarea) => {
      textarea.classList.add("form-control");
    });
  }, 2000);
}

// Small fix for the demo megamenu/mobile-menu
// remove active classes
if (window.location.href.includes("ecomify")) {
  document.querySelectorAll(".dropdown-megamenu .dropdown-item.active").forEach((item) => {
    item.classList.remove("active");
  });
  document.querySelectorAll("#offcanvas-menu .dropdown-item.active").forEach((item) => {
    item.classList.remove("active");
  });
}

/*
    Prev/Next Articles in the Article view page
*/
const initPrevNextArticleButtons = async () => {
  const wrapper = document.querySelector("#article-prev-next");

  if (!wrapper) return;

  await new Promise((resolve) => setTimeout(resolve, 1000));

  const threshold = 600;

  window.addEventListener("scroll", () => {
    if (window.scrollY > threshold) {
      wrapper.classList.add("show");
    } else {
      wrapper.classList.remove("show");
    }
  });
};
initPrevNextArticleButtons();

/*
    Prive widget 
*/
const fixPriveWidget = () => {
  const myInterval = setInterval(() => {
    const widget = document.querySelector(".prive-widget");
    if (widget) {
      widget.querySelectorAll(".prive_input_radio").forEach((radio) => {
        radio.classList.add("form-check-input");
      });

      widget.querySelector(".prive_delivery_every_box").insertAdjacentHTML(
        "beforeend",
        `
                <ul class="prive-sub-benefits">
                    <li>No commitment, cancel anytime</li>
                </ul>
            `,
      );

      clearInterval(myInterval);
    }
  }, 2000);
};
fixPriveWidget();

document.addEventListener("DOMContentLoaded", function () {
  // Query all elements with data-scroll-to
  const scrollButtons = document.querySelectorAll("[data-scroll-to]");

  scrollButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default link behavior if applicable

      const scrollSetting = this.dataset.scrollTo; // e.g., '2' or 'last'
      const offsetFromTop = parseInt(this.dataset.scrollOffset || "80", 10); // Default to 80px, customizable per-button

      // Get all top-level sections under main
      const allSections = Array.from(document.querySelectorAll("main > .shopify-section"));

      let targetSection;

      if (scrollSetting === "last") {
        // Find the last non-footer section
        const footer = document.querySelector(".lp-footer"); // Adjust selector if your footer class differs
        const footerSection = footer ? footer.closest(".shopify-section") : null;
        const footerIndex = footerSection ? allSections.indexOf(footerSection) : -1;
        if (footerIndex > 0) {
          targetSection = allSections[footerIndex - 1];
        } else {
          targetSection = allSections[allSections.length - 1]; // Fallback to absolute last section
        }
      } else {
        const index = parseInt(scrollSetting, 10);
        if (!isNaN(index) && index > 0 && index <= allSections.length) {
          targetSection = allSections[index - 1]; // 1-based index
        }
      }

      if (targetSection) {
        const y = targetSection.getBoundingClientRect().top + window.scrollY - offsetFromTop;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else if (this.href && this.href !== window.location.href && this.href !== "#") {
        // Fallback to navigating the href if scrolling fails (e.g., invalid target)
        window.location.href = this.href;
      }
    });
  });
});

/** Components  **/

document.addEventListener("DOMContentLoaded", () => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function open(content, chev) {
    // Start from 0 -> target px; after transition, release to 'none'
    content.classList.add("is-open");
    const target = content.scrollHeight;
    content.style.maxHeight = target + "px";

    if (!reduceMotion) {
      const onEnd = (e) => {
        if (e.propertyName === "max-height") {
          content.style.maxHeight = "none";
          content.removeEventListener("transitionend", onEnd);
        }
      };
      content.addEventListener("transitionend", onEnd);
    } else {
      content.style.maxHeight = "none";
    }
    chev?.classList.add("rotate-180");
  }

  function close(content, chev) {
    // From 'none' or open state -> lock current px -> 0
    const current = content.getBoundingClientRect().height;
    content.style.maxHeight = current + "px";
    // force reflow
    content.offsetHeight;
    content.style.maxHeight = "0px";
    content.classList.remove("is-open");
    chev?.classList.remove("rotate-180");
  }

  // Set initial state based on aria-expanded
  document.querySelectorAll(".product-accordion").forEach((acc) => {
    const btn = acc.querySelector(".js-accordion-toggle");
    const panel = acc.querySelector(".product-accordion-content");
    const chev = btn?.querySelector(".chev");
    const expanded = btn?.getAttribute("aria-expanded") === "true";
    if (expanded) {
      panel.classList.add("is-open");
      panel.style.maxHeight = "none";
      chev?.classList.add("rotate-180");
    } else {
      panel.style.maxHeight = "0px";
    }
  });

  // Toggle
  document.body.addEventListener("click", (e) => {
    const btn = e.target.closest(".js-accordion-toggle");
    if (!btn) return;
    const acc = btn.closest(".product-accordion");
    const panel = acc.querySelector(".product-accordion-content");
    const chev = btn.querySelector(".chev");

    const expanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", String(!expanded));

    if (!expanded) {
      if (getComputedStyle(panel).maxHeight === "none") panel.style.maxHeight = "0px";
      open(panel, chev);
    } else {
      close(panel, chev);
    }
  });

  // Keep open panels sized on resize
  window.addEventListener("resize", () => {
    document.querySelectorAll(".product-accordion-content.is-open").forEach((panel) => {
      if (getComputedStyle(panel).maxHeight !== "none") return;
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.offsetHeight;
      panel.style.maxHeight = "none";
    });
  });
});
